export enum CustomerFleetType {
  Global = 'GLOBAL',
  Specific = 'SPECIFIC'
}
